import { initPlasmicLoader } from '@plasmicapp/loader-nextjs/react-server-conditional';
import { isProductionEnv } from '~/lib/env';

const id = process.env.NEXT_PUBLIC_PLASMIC_PROJECT_ID || '';
const token = process.env.NEXT_PUBLIC_PLASMIC_API_TOKEN || '';
const isProd = isProductionEnv();

// Preview means plasmic changes don't need to be "published"
// and are visible on the app instantly
// We only want this for non production environments
const preview = !isProd;

export const PLASMIC = initPlasmicLoader({
  projects: [{ id, token }],
  preview,
});
